import React from 'react';
import DatePicker from "react-datepicker";

const BaseDatePicker = (props) => {
    return (
        <DatePicker {...props}/>
    )
}

export default BaseDatePicker;